import { BarSurface } from './surfaces/BarSurface';
import { FloatingSurface } from './surfaces/FloatingSurface';
import { FullscreenSurface } from './surfaces/FullscreenSurface';
import { InlineSurface } from './surfaces/InlineSurface';
import { ModalSurface } from './surfaces/ModalSurface';
import { SlideInSurface } from './surfaces/SlideInSurface';
import type { SurfaceProps } from './surfaces/common';
import type { LayerDelivery } from './types';

/** Zvolí povrch podle `kind`. Jediné místo, kde se mapuje typ → komponenta. */
export function LayerSurface({ layer, ...rest }: SurfaceProps & { layer: LayerDelivery }) {
  switch (layer.kind) {
    case 'modal':
      return <ModalSurface layer={layer} {...rest} />;
    case 'fullscreen':
      return <FullscreenSurface layer={layer} {...rest} />;
    case 'slide_in':
      return <SlideInSurface layer={layer} {...rest} />;
    case 'top_bar':
    case 'bottom_bar':
    case 'announcement':
      return <BarSurface layer={layer} {...rest} />;
    case 'floating':
    case 'floating_widget':
      return <FloatingSurface layer={layer} {...rest} />;
    case 'banner':
    case 'inline':
    case 'recommendation':
      return <InlineSurface layer={layer} {...rest} />;
    default:
      return null;
  }
}
